import { themeTitleParts } from '../../helpers/intelligence/themeTitle'
import telwoord from '../../helpers/intelligence/telwoord'

/**
 * De cijfers van een thema als zin. Drie getallen, elk met zijn eigen
 * betekenis erbij — kaal naast elkaar lezen ze als één telling.
 *
 * De dekkingsgraad kan ontbreken (de Research-brug is dan niet geraadpleegd);
 * dat is 'niet gemeten' en nooit 0%.
 * AI-CONTEXT: See docs/pitfalls.md#ui-aggregate-collapses-nothing-into-zero
 *
 * @param {{resolved: number, total: number}|null|undefined} coverage
 * @returns {string}
 */
const dekking = (coverage) => {
    // Ook een totaal van 0 is 'niet gemeten': 0 van 0 is geen 0%.
    if (!coverage || typeof coverage.resolved !== 'number' || typeof coverage.total !== 'number' || coverage.total <= 0) {
        return 'dekkingsgraad niet gemeten'
    }
    const pct = Math.round((coverage.resolved / coverage.total) * 100)
    return `${pct}% van de antwoorden op dit effect is herleidbaar naar een doelgroep`
}

/**
 * De kop van het themadetail: naam en de cijfers die het thema draagt.
 *
 * `orgsOnEffect` heet hier wat het is: organisaties met een ontworpen pad (een
 * gecategoriseerd mechanisme) op dit effect — NIET 'organisaties die dit
 * effect meten', dat is een grotere groep (inbox #200).
 *
 * @param {object} props
 * @param {object} props.theme - Het thema (buildThemes + attachThemeStats); `organisations` = [{id, name}] uit getThemes
 */
const ThemeHeader = ({ theme }) => {
    const { effect, targetgroup } = themeTitleParts(theme)
    return (
        <div className="intelligence-theme-header">
            <h2 className="intelligence-theme-header__title">
                {effect}{targetgroup ? ` voor ${targetgroup}` : ''}
            </h2>
            <ul className="intelligence-theme-header__stats">
                <li>{telwoord(theme.orgs || 0, 'organisatie richt', 'organisaties richten')} zich op deze doelgroep</li>
                <li>{telwoord(theme.orgsOnEffect || 0, 'organisatie', 'organisaties')} met een ontworpen pad op dit effect</li>
                <li>{dekking(theme.coverage)}</li>
            </ul>
            {/* Wélke organisaties: intern, voor de redacteur. Alleen als de
                functie de lijst meegeeft — een ontbrekende lijst is 'onbekend',
                geen 'niemand'. */}
            {Array.isArray(theme.organisations) && theme.organisations.length > 0 && (
                <ul className="intelligence-theme-header__orgs" aria-label="Organisaties op dit thema">
                    {theme.organisations.map((org) => (
                        <li key={org.id} className="intelligence-tag">{org.name}</li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default ThemeHeader
